import React, { Component } from "react";
import { Button, Dialog, FormControl } from "@mui/material";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CommonConfig from "../../utils/constant";
import { OverlayPanel } from "primereact/overlaypanel";
import userImage from "../../assets/images/user.png";
import APIConstant from "../../utils/pathConstant";
import api from "../../utils/apiClient";
import Toast from "../Shared/Toast/Toast";
import Loader from "../Shared/Loader/Loader";
import Grid from '@mui/material/Grid';
import { default as routes } from "../../routes";
import equatorLogo from "../../assets/svgs/equatorLogo.svg"
import { Link } from "react-router-dom";

const initialState = {
  mainTitle: "",
  breadCrumb: "",
  loginID: "",
  Name: "",
  Email: "",
  Role: "",
  LastLogin: "",
  changePassword: false,

  oldPassword: "",
  oldPasswordErr: "",
  oldPasswordErrText: "",

  newPassword: "",
  newPasswordErr: "",
  newPasswordErrText: "",

  confirmPassword: "",
  confirmPasswordErr: "",
  confirmPasswordErrText: "",

  profilePath: "",
  loaded: false,
  openOverlay: false,
  menus: [],
  menuList: [],

  taskAccess: [],
  projectAccess: [],
  leaveAccess: [],
  userAccess: [],
};
export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { initialState };
  }

  componentDidMount = async () => {
    this.setState({
      loginID: CommonConfig.loginData().LoginID,
      Role: CommonConfig.loginData().Role,
      Name: CommonConfig.loginData().Name,
      LastLogin: CommonConfig.loginData().LastLogin,
    });
    var userData = JSON.parse(localStorage.getItem('UserAccess'));
    // console.log(typeof (userData[0]))
    this.setState({
      taskAccess: userData?.[0]?.ViewAccess,
      projectAccess: userData?.[1],
      leaveAccess: userData?.[2],
      userAccess: userData?.[3],
    })
    console.log("project access", this.state.taskAccess)

    await this.getUserProfileByID();
    // await this.getUserMenuByID();

  };

  getUserMenu = () => {
    let data = {
      SecurityUserID: CommonConfig.loginData().SecurityUserID,
    }
    try {
      api.post(APIConstant.path.getUserMenu, data)
        .then(async (res) => {
          let response = await res;
          if (response.success) {
            this.setState({ menus: response.data })
            localStorage.setItem('userModuleAccess', JSON.stringify(response.data))
          } else {

          }
        })
        .catch((err) => {
          Toast.error({ message: err });
        })
    } catch (err) {
      Toast.error({ message: err });
    }
  }

  getUserProfileByID = async () => {
    try {
      let data = {
        UserID: CommonConfig.loginData().SecurityUserID,
      };
      api
        .post(APIConstant.path.getUserProfileByID, data)
        .then(async (res) => {
          let response = await res;
          if (response.success) {
            this.setState({
              profilePath: response.data[0].PicturePath,
            });
          } else {
          }
        })
        .catch((err) => { });
    } catch (err) { }
  };

  // getUserMenuByID = async (ID) => {
  //   debugger
  //   let data = {
  //     SecurityUserID: ID,
  //   }
  //   try {
  //     await api.post(APIConstant.path.getUserMenuByID, data)
  //       .then(async (res) => {
  //         let response = await res;
  //         if (response.success) {
  //           this.setState({
  //             taskAccess: response.data[0],
  //             projectAccess: response.data[1],
  //             leaveAccess: response.data[2],
  //             userAccess: response.data[3],
  //           })
  //         } else {

  //         }
  //       })
  //       .catch((err) => {
  //         Toast.error({ message: err });
  //       })
  //   } catch (err) {
  //     Toast.error({ message: err });
  //   }
  // }
  handleLogout = () => {
    this.props.history.push("/login");
    localStorage.clear();
    Toast.success({ message: "Logged out success" });
  };

  changePassword = (e) => {
    Loader.show();
    e.preventDefault();
    if (this.validate()) {
      try {
        let data = {
          UserID: CommonConfig.loginData().SecurityUserID,
          CurrentPassword: this.state.oldPassword,
          NewPassword: this.state.newPassword,
        };
        api.post(APIConstant.path.userChangePassword, data).then((response) => {
          if (response.success) {
            this.props.history.push("/dashboard");
            this.setState(initialState);
            Toast.success({ message: response.message });
            Loader.hide();
          } else {
            Toast.error({ message: response.message });
            Loader.hide();
          }
        });
      } catch (err) {
        Toast.error({ message: err });
        Loader.hide();
      }
    }
  };

  openModel = () => {
    this.setState({ changePassword: true });
  };

  handleClose = () => {
    this.setState({ changePassword: false });
  };

  handleChange = (e, type) => {
    if (type === "oldPassword") {
      if (CommonConfig.isEmpty(e.target.value)) {
        this.setState({
          oldPassword: e.target.value,
          oldPasswordErr: true,
          oldPasswordErrText: "Old password is required",
        });
      } else {
        this.setState({
          oldPassword: e.target.value,
          oldPasswordErr: false,
          oldPasswordErrText: "",
        });
      }
    }

    if (type === "newPassword") {
      if (CommonConfig.isEmpty(e.target.value)) {
        this.setState({
          newPassword: e.target.value,
          newPasswordErr: true,
          newPasswordErrText: "New password is required",
        });
      } else {
        this.setState({
          newPassword: e.target.value,
          newPasswordErr: false,
          newPasswordErrText: "",
        });
      }
    }

    if (type === "confirmPassword") {
      if (CommonConfig.isEmpty(e.target.value)) {
        this.setState({
          confirmPassword: e.target.value,
          confirmPasswordErr: true,
          confirmPasswordErrText: "Confirm password is required",
        });
      } else if (this.state.newPassword !== e.target.value) {
        this.setState({
          confirmPassword: e.target.value,
          confirmPasswordErr: true,
          confirmPasswordErrText: "  Confirm password does not match ",
        });
      } else {
        this.setState({
          confirmPassword: e.target.value,
          confirmPasswordErr: false,
          confirmPasswordErrText: "",
        });
      }
    }
  };

  validate = (e) => {
    let isValid = true;
    if (this.state.oldPassword === "" || this.state.oldPassword == null) {
      this.setState({
        oldPasswordErr: true,
        oldPasswordErrText: "Please enter old password",
      });
      isValid = false;
    } else {
      this.setState({ oldPasswordErr: false, oldPasswordErrText: "" });
    }

    if (this.state.newPassword === "" || this.state.newPassword == null) {
      this.setState({
        newPasswordErr: true,
        newPasswordErrText: "Please enter new password",
      });
      isValid = false;
    } else {
      this.setState({ newPasswordErr: false, newPasswordErrText: "" });
    }

    if (
      this.state.confirmPassword === "" ||
      this.state.confirmPassword == null
    ) {
      this.setState({
        confirmPasswordErr: true,
        confirmPasswordErrText: "Please enter new password",
      });
      isValid = false;
    } else {
      this.setState({ confirmPasswordErr: false, confirmPasswordErrText: "" });
    }

    if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({
        confirmPasswordErr: true,
        confirmPasswordErrText: "Confirm password does not match",
      });
      isValid = false;
    } else {
      this.setState({ confirmPasswordErr: false, confirmPasswordErrText: "" });
    }
    return isValid;
  };

  sideBarClose = () => {
    document.getElementById("sidebar").classList.toggle("close-sidebar");
    document.getElementById("dashboard").classList.toggle("lg-dashboard");
  };

  render() {
    const { taskAccess,
      projectAccess,
      leaveAccess,
      userAccess,
      menuList,
      menus,
      Name,
      Email,
      LastLogin,
      loginID,
      Role,
      changePassword,
      oldPassword,
      newPassword,
      oldPasswordErr,
      oldPasswordErrText,
      newPasswordErr,
      newPasswordErrText,
      confirmPassword,
      confirmPasswordErr,
      confirmPasswordErrText,
      profilePath,
    } = this.state;

    return (
      <nav>
        <Grid container>
          <Grid item md={8} sm={2}>
            <Grid container>
              <Grid item md={4}>
                <div class="logo-box-dashboard">
                  <img src={equatorLogo} />
                </div>
              </Grid>
              <Grid item md={8} className="d-none d-lg-block">

                <ul class="menu-list">
                  {/* {this.state.menus?.map((menuItem, idx) => {
                    return (
                      <li class="menu-item active" key={idx}>
                        <Link to={menuItem.Path}>{menuItem.MenuName}</Link>
                      </li>
                    )

                  })} */}
                  {Role === "Project Manager" ||
                    Role === "CEO" ||
                    Role === "HR" ? (
                    <>
                      <Link className='menu-item' to="/User">Users</Link>
                      <Link className='menu-item' to='/project'>Projects</Link>
                    </>

                  ) : null}
                  <Link className='menu-item' to='/task'>Dashboard</Link>
                  <Link className='menu-item' to='/task'>Tasks</Link>
                </ul>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} sm={10}>
            <Grid container spacing={2}>
              <Grid item md={7} sm={3}>
                <div class="search-notification ">
                  <div class="search-box d-none d-lg-block">
                    <input type="text" placeholder="Search tasks" />
                    <span class="search-icon">
                      <i class="fa-solid fa-magnifying-glass"></i>
                    </span>
                  </div>
                  <div class="notification-icon">
                    <svg width="25" height="30" viewBox="0 0 25 30" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M23.6757 19.7976C22.824 19.2574 21.4273 17.5096 21.4273 11.8213C21.4273 6.48276 17.9525 4.35352 15.3975 3.46374C15.4315 3.27311 15.4657 3.05056 15.4657 2.8599C15.4657 1.271 14.1032 0 12.3999 0C10.6966 0 9.33412 1.271 9.33412 2.8599C9.33412 3.05054 9.3681 3.27308 9.40232 3.46374C6.84737 4.3218 3.37259 6.48259 3.37259 11.8213C3.37259 17.5414 1.97582 19.2892 1.12418 19.7976C0.40867 20.2425 0 21.0052 0 21.7678C0 23.1025 1.15818 24.1511 2.55494 24.1511H22.2451C23.6418 24.1511 24.8 23.0707 24.8 21.7678C24.7998 21.0052 24.391 20.2425 23.6758 19.7976H23.6757ZM12.3999 1.27106C13.3537 1.27106 14.1032 1.97018 14.1032 2.85996C14.1032 2.95528 14.1032 3.01889 14.0692 3.11421C12.6724 2.82826 11.3781 2.9872 10.6966 3.11421C10.6966 3.01889 10.6626 2.95528 10.6626 2.85996C10.6966 1.97018 11.4461 1.27106 12.3999 1.27106H12.3999ZM22.2449 22.9118H2.55481C1.9075 22.9118 1.36238 22.4033 1.36238 21.7995C1.36238 21.4182 1.56674 21.0687 1.90749 20.8781C3.78118 19.6704 4.73496 16.6516 4.73496 11.8531C4.73496 7.02281 7.93722 5.17975 10.5943 4.48063H10.6283C10.6283 4.48063 11.3777 4.25808 12.4338 4.25808C12.9789 4.25808 13.558 4.3217 14.2053 4.51233H14.2392C16.8964 5.21145 20.0986 7.05462 20.0986 11.8848C20.0986 14.9037 20.4733 17.2234 21.2228 18.8124H7.2898C6.91506 18.8124 6.60854 19.0984 6.60854 19.4479C6.60854 19.7975 6.91508 20.0834 7.2898 20.0834H21.9381H21.9721C22.2447 20.433 22.5512 20.6873 22.892 20.9096C23.2327 21.1321 23.4371 21.4815 23.4371 21.831C23.4371 22.4034 22.892 22.9119 22.2446 22.9119L22.2449 22.9118Z"
                        fill="white" />
                      <path
                        d="M12.7404 29.9099C14.8524 29.9099 16.6579 28.448 16.9646 26.5095L17.0668 25.7787H8.41406L8.51624 26.5095C8.82302 28.448 10.6285 29.9099 12.7405 29.9099H12.7404ZM15.3635 27.0497C14.9206 28.0031 13.8646 28.6386 12.7404 28.6386C11.6162 28.6386 10.5602 28.0031 10.1173 27.0497H15.3635Z"
                        fill="white" />
                      <path
                        d="M6.20007 20.1223C6.20007 20.0906 6.16609 20.0587 6.13187 20.027C6.09789 19.9953 6.09789 19.9634 6.06368 19.9317C5.8251 19.6774 5.34817 19.6774 5.10983 19.9317C5.07585 19.9634 5.04163 19.9953 5.04163 20.027C5.00765 20.0587 5.00765 20.0906 4.97343 20.1223C4.93945 20.154 4.93945 20.1859 4.93945 20.2493V20.3763C4.93945 20.5353 5.00765 20.6942 5.14381 20.8212C5.24623 20.9484 5.41661 21.0121 5.58674 21.0121C5.75712 21.0121 5.9275 20.9484 6.06365 20.8214C6.13185 20.7578 6.16583 20.6944 6.19981 20.6308C6.23379 20.5672 6.26801 20.4719 6.26801 20.3765V20.2495C6.23403 20.2176 6.23403 20.154 6.20005 20.1223L6.20007 20.1223Z"
                        fill="#263238" />
                    </svg>
                  </div>
                </div>
              </Grid>

              <Grid item md={5} sm={9} className="d-flex align-items-center gap-2">
                <div class="user-profile" onClick={(e) => {
                  this.setState({ openOverlay: !this.state.openOverlay });
                }}>
                  <div class="profile-img">
                    <img src={
                      CommonConfig.isEmpty(profilePath)
                        ? userImage
                        : profilePath
                    } />
                  </div>
                  <div class="profile-info d-none d-lg-block">
                    <div class="username">
                      <p>{this.state.Name}</p>
                    </div>
                    <div class="usertype">
                      <span class="usertype-badge">
                        <p>{this.state.Role}</p>
                      </span>
                    </div>
                  </div>
                  {this.state.openOverlay ? (
                    <div className="toggle-overlay">
                      <div className="main-overlay">
                        <div className="profile-detail">
                          <div
                            className="profile-img"
                            style={{ marginTop: "22px" }}
                          >
                            <img
                              src={
                                CommonConfig.isEmpty(profilePath)
                                  ? userImage
                                  : profilePath
                              }
                            />
                          </div>
                          <div className="profile-info">
                            <div className="username-overlay">
                              <p className="text-dark">{Name}</p>
                            </div>
                            <div className="usertype">
                              <span className="usertype-overlay-badge">
                                <p>{Role}</p>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="overlay-item">
                          <ul>
                            <li
                              onClick={() =>
                                this.props.history.push({
                                  pathname: "/edit-profile",
                                })
                              }
                            >
                              <div className="list-item">
                                <div className="list-item-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                  >
                                    <path
                                      d="M8.49979 0C3.81276 0 0 3.8134 0 8.49979C0 10.9655 1.05113 13.2025 2.7554 14.7654L2.75116 14.7682L2.84265 14.8455C3.56063 15.4853 4.3908 16.0048 5.30647 16.3735C5.35778 16.3945 5.40858 16.4175 5.46025 16.4376C5.56785 16.4786 5.67719 16.515 5.78692 16.5518C5.90525 16.5916 6.0247 16.6285 6.1449 16.6631C6.2299 16.6876 6.31453 16.713 6.40041 16.7346C6.6171 16.7899 6.83566 16.839 7.05659 16.8769C7.07419 16.8801 7.09154 16.8815 7.10889 16.8815C7.25692 16.8815 7.38723 16.7752 7.4132 16.6247C7.44191 16.4565 7.32932 16.2969 7.16093 16.2684C7.16031 16.2684 7.15981 16.2677 7.15919 16.2677C6.95648 16.2331 6.758 16.1873 6.56168 16.1378C6.4934 16.1204 6.42513 16.1028 6.35747 16.0837C6.22554 16.0466 6.0961 16.0049 5.96741 15.9616C5.8135 15.9095 5.66147 15.8527 5.51155 15.7909C5.44877 15.7652 5.38586 15.7402 5.32407 15.713C5.19613 15.6564 5.06919 15.597 4.94436 15.5336C4.93288 15.5278 4.92202 15.5218 4.91053 15.5161C4.49887 15.3047 4.10433 15.0575 3.73334 14.7756C3.74445 14.7691 3.75494 14.7628 3.76567 14.7567L6.21003 13.4236C6.63007 13.1943 6.89117 12.7547 6.89117 12.276V11.1623L6.81927 11.0769C6.81315 11.0694 6.14686 10.2623 5.89235 9.15541L5.86463 9.03333L5.75891 8.96493C5.61025 8.86882 5.52125 8.70805 5.52125 8.53467V7.43899C5.52125 7.29533 5.58291 7.16152 5.69388 7.06104L5.79598 6.96855V5.2469L5.79274 5.2067C5.79186 5.19934 5.70074 4.45591 6.22437 3.85914C6.67199 3.3495 7.43751 3.09086 8.50037 3.09086C9.55898 3.09086 10.3229 3.34737 10.7709 3.85313C11.2939 4.44377 11.2085 5.20095 11.2079 5.20718L11.205 6.96939L11.3067 7.06126C11.4177 7.16136 11.479 7.29542 11.479 7.43921V8.53488C11.479 8.75869 11.3324 8.9539 11.1143 9.02132C10.9514 9.07175 10.8596 9.24525 10.9097 9.40851C10.9597 9.5714 11.133 9.66277 11.2961 9.61246C11.7752 9.46443 12.0972 9.03167 12.0972 8.53488V7.4392C12.0972 7.17159 11.9987 6.91122 11.8232 6.70688V5.26457C11.8393 5.1038 11.8964 4.19934 11.2414 3.45254C10.6722 2.80222 9.74996 2.47245 8.50065 2.47245C7.25134 2.47245 6.32953 2.80174 5.75985 3.45178C5.10492 4.19858 5.16196 5.10403 5.17806 5.26418V6.70685C5.00244 6.91118 4.90371 7.17156 4.90371 7.43917V8.53484C4.90371 8.87509 5.05674 9.19252 5.31787 9.40671C5.56825 10.3874 6.08326 11.1297 6.27374 11.3814V12.276C6.27374 12.5282 6.13594 12.7601 5.91438 12.8812L3.47076 14.2143C3.391 14.2579 3.31224 14.3083 3.23335 14.3652C1.61756 12.9138 0.618609 10.8154 0.618609 8.50004C0.618609 4.15396 4.15433 0.618239 8.50041 0.618239C12.8465 0.618239 16.3819 4.15396 16.3819 8.50004C16.3819 8.67092 16.5206 8.80897 16.6911 8.80897C16.8617 8.80897 17 8.67104 17 8.50004C17 3.81333 13.1876 0.000246564 8.50021 0.000246564L8.49979 0ZM15.5057 10.2001C15.4277 10.2001 15.3496 10.2299 15.29 10.2894L14.4128 11.1669L15.7242 12.4776L16.602 11.6003C16.7207 11.4816 16.7204 11.2885 16.602 11.1701L15.7209 10.2886C15.6616 10.2294 15.5836 10.2 15.5056 10.2L15.5057 10.2001ZM13.9759 11.6036L10.8095 14.7692L12.1215 16.081L15.2872 12.9149L13.9758 11.6036H13.9759ZM10.5306 15.3649L10.1574 16.7337L11.5262 16.3601L10.5308 15.365L10.5306 15.3649Z"
                                      fill="black"
                                    />
                                  </svg>
                                </div>
                                <div className="list-item-title">
                                  <a href="javascript:;">Edit Profile</a>
                                </div>
                              </div>
                            </li>
                            <li onClick={(e) => this.openModel(e)}>
                              <div className="list-item">
                                <div className="list-item-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                  >
                                    <path
                                      d="M8.49979 0C3.81276 0 0 3.8134 0 8.49979C0 10.9655 1.05113 13.2025 2.7554 14.7654L2.75116 14.7682L2.84265 14.8455C3.56063 15.4853 4.3908 16.0048 5.30647 16.3735C5.35778 16.3945 5.40858 16.4175 5.46025 16.4376C5.56785 16.4786 5.67719 16.515 5.78692 16.5518C5.90525 16.5916 6.0247 16.6285 6.1449 16.6631C6.2299 16.6876 6.31453 16.713 6.40041 16.7346C6.6171 16.7899 6.83566 16.839 7.05659 16.8769C7.07419 16.8801 7.09154 16.8815 7.10889 16.8815C7.25692 16.8815 7.38723 16.7752 7.4132 16.6247C7.44191 16.4565 7.32932 16.2969 7.16093 16.2684C7.16031 16.2684 7.15981 16.2677 7.15919 16.2677C6.95648 16.2331 6.758 16.1873 6.56168 16.1378C6.4934 16.1204 6.42513 16.1028 6.35747 16.0837C6.22554 16.0466 6.0961 16.0049 5.96741 15.9616C5.8135 15.9095 5.66147 15.8527 5.51155 15.7909C5.44877 15.7652 5.38586 15.7402 5.32407 15.713C5.19613 15.6564 5.06919 15.597 4.94436 15.5336C4.93288 15.5278 4.92202 15.5218 4.91053 15.5161C4.49887 15.3047 4.10433 15.0575 3.73334 14.7756C3.74445 14.7691 3.75494 14.7628 3.76567 14.7567L6.21003 13.4236C6.63007 13.1943 6.89117 12.7547 6.89117 12.276V11.1623L6.81927 11.0769C6.81315 11.0694 6.14686 10.2623 5.89235 9.15541L5.86463 9.03333L5.75891 8.96493C5.61025 8.86882 5.52125 8.70805 5.52125 8.53467V7.43899C5.52125 7.29533 5.58291 7.16152 5.69388 7.06104L5.79598 6.96855V5.2469L5.79274 5.2067C5.79186 5.19934 5.70074 4.45591 6.22437 3.85914C6.67199 3.3495 7.43751 3.09086 8.50037 3.09086C9.55898 3.09086 10.3229 3.34737 10.7709 3.85313C11.2939 4.44377 11.2085 5.20095 11.2079 5.20718L11.205 6.96939L11.3067 7.06126C11.4177 7.16136 11.479 7.29542 11.479 7.43921V8.53488C11.479 8.75869 11.3324 8.9539 11.1143 9.02132C10.9514 9.07175 10.8596 9.24525 10.9097 9.40851C10.9597 9.5714 11.133 9.66277 11.2961 9.61246C11.7752 9.46443 12.0972 9.03167 12.0972 8.53488V7.4392C12.0972 7.17159 11.9987 6.91122 11.8232 6.70688V5.26457C11.8393 5.1038 11.8964 4.19934 11.2414 3.45254C10.6722 2.80222 9.74996 2.47245 8.50065 2.47245C7.25134 2.47245 6.32953 2.80174 5.75985 3.45178C5.10492 4.19858 5.16196 5.10403 5.17806 5.26418V6.70685C5.00244 6.91118 4.90371 7.17156 4.90371 7.43917V8.53484C4.90371 8.87509 5.05674 9.19252 5.31787 9.40671C5.56825 10.3874 6.08326 11.1297 6.27374 11.3814V12.276C6.27374 12.5282 6.13594 12.7601 5.91438 12.8812L3.47076 14.2143C3.391 14.2579 3.31224 14.3083 3.23335 14.3652C1.61756 12.9138 0.618609 10.8154 0.618609 8.50004C0.618609 4.15396 4.15433 0.618239 8.50041 0.618239C12.8465 0.618239 16.3819 4.15396 16.3819 8.50004C16.3819 8.67092 16.5206 8.80897 16.6911 8.80897C16.8617 8.80897 17 8.67104 17 8.50004C17 3.81333 13.1876 0.000246564 8.50021 0.000246564L8.49979 0ZM15.5057 10.2001C15.4277 10.2001 15.3496 10.2299 15.29 10.2894L14.4128 11.1669L15.7242 12.4776L16.602 11.6003C16.7207 11.4816 16.7204 11.2885 16.602 11.1701L15.7209 10.2886C15.6616 10.2294 15.5836 10.2 15.5056 10.2L15.5057 10.2001ZM13.9759 11.6036L10.8095 14.7692L12.1215 16.081L15.2872 12.9149L13.9758 11.6036H13.9759ZM10.5306 15.3649L10.1574 16.7337L11.5262 16.3601L10.5308 15.365L10.5306 15.3649Z"
                                      fill="black"
                                    />
                                  </svg>
                                </div>
                                <div className="list-item-title">
                                  <a href="javascript:;" onClick={() => this.handleOpen("changePassword")}>Change Password</a>
                                </div>
                              </div>
                            </li>
                            <li onClick={(e) => this.handleLogout()}>
                              <div className="list-item">
                                <div className="list-item-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                  >
                                    <path
                                      d="M8.49979 0C3.81276 0 0 3.8134 0 8.49979C0 10.9655 1.05113 13.2025 2.7554 14.7654L2.75116 14.7682L2.84265 14.8455C3.56063 15.4853 4.3908 16.0048 5.30647 16.3735C5.35778 16.3945 5.40858 16.4175 5.46025 16.4376C5.56785 16.4786 5.67719 16.515 5.78692 16.5518C5.90525 16.5916 6.0247 16.6285 6.1449 16.6631C6.2299 16.6876 6.31453 16.713 6.40041 16.7346C6.6171 16.7899 6.83566 16.839 7.05659 16.8769C7.07419 16.8801 7.09154 16.8815 7.10889 16.8815C7.25692 16.8815 7.38723 16.7752 7.4132 16.6247C7.44191 16.4565 7.32932 16.2969 7.16093 16.2684C7.16031 16.2684 7.15981 16.2677 7.15919 16.2677C6.95648 16.2331 6.758 16.1873 6.56168 16.1378C6.4934 16.1204 6.42513 16.1028 6.35747 16.0837C6.22554 16.0466 6.0961 16.0049 5.96741 15.9616C5.8135 15.9095 5.66147 15.8527 5.51155 15.7909C5.44877 15.7652 5.38586 15.7402 5.32407 15.713C5.19613 15.6564 5.06919 15.597 4.94436 15.5336C4.93288 15.5278 4.92202 15.5218 4.91053 15.5161C4.49887 15.3047 4.10433 15.0575 3.73334 14.7756C3.74445 14.7691 3.75494 14.7628 3.76567 14.7567L6.21003 13.4236C6.63007 13.1943 6.89117 12.7547 6.89117 12.276V11.1623L6.81927 11.0769C6.81315 11.0694 6.14686 10.2623 5.89235 9.15541L5.86463 9.03333L5.75891 8.96493C5.61025 8.86882 5.52125 8.70805 5.52125 8.53467V7.43899C5.52125 7.29533 5.58291 7.16152 5.69388 7.06104L5.79598 6.96855V5.2469L5.79274 5.2067C5.79186 5.19934 5.70074 4.45591 6.22437 3.85914C6.67199 3.3495 7.43751 3.09086 8.50037 3.09086C9.55898 3.09086 10.3229 3.34737 10.7709 3.85313C11.2939 4.44377 11.2085 5.20095 11.2079 5.20718L11.205 6.96939L11.3067 7.06126C11.4177 7.16136 11.479 7.29542 11.479 7.43921V8.53488C11.479 8.75869 11.3324 8.9539 11.1143 9.02132C10.9514 9.07175 10.8596 9.24525 10.9097 9.40851C10.9597 9.5714 11.133 9.66277 11.2961 9.61246C11.7752 9.46443 12.0972 9.03167 12.0972 8.53488V7.4392C12.0972 7.17159 11.9987 6.91122 11.8232 6.70688V5.26457C11.8393 5.1038 11.8964 4.19934 11.2414 3.45254C10.6722 2.80222 9.74996 2.47245 8.50065 2.47245C7.25134 2.47245 6.32953 2.80174 5.75985 3.45178C5.10492 4.19858 5.16196 5.10403 5.17806 5.26418V6.70685C5.00244 6.91118 4.90371 7.17156 4.90371 7.43917V8.53484C4.90371 8.87509 5.05674 9.19252 5.31787 9.40671C5.56825 10.3874 6.08326 11.1297 6.27374 11.3814V12.276C6.27374 12.5282 6.13594 12.7601 5.91438 12.8812L3.47076 14.2143C3.391 14.2579 3.31224 14.3083 3.23335 14.3652C1.61756 12.9138 0.618609 10.8154 0.618609 8.50004C0.618609 4.15396 4.15433 0.618239 8.50041 0.618239C12.8465 0.618239 16.3819 4.15396 16.3819 8.50004C16.3819 8.67092 16.5206 8.80897 16.6911 8.80897C16.8617 8.80897 17 8.67104 17 8.50004C17 3.81333 13.1876 0.000246564 8.50021 0.000246564L8.49979 0ZM15.5057 10.2001C15.4277 10.2001 15.3496 10.2299 15.29 10.2894L14.4128 11.1669L15.7242 12.4776L16.602 11.6003C16.7207 11.4816 16.7204 11.2885 16.602 11.1701L15.7209 10.2886C15.6616 10.2294 15.5836 10.2 15.5056 10.2L15.5057 10.2001ZM13.9759 11.6036L10.8095 14.7692L12.1215 16.081L15.2872 12.9149L13.9758 11.6036H13.9759ZM10.5306 15.3649L10.1574 16.7337L11.5262 16.3601L10.5308 15.365L10.5306 15.3649Z"
                                      fill="black"
                                    />
                                  </svg>
                                </div>
                                <div className="list-item-title">
                                  <a href="javascript:;">Logout</a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="last-login-info">
                          <p>Last login: {LastLogin}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="mobile-menu d-lg-none">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.955149 13.5232H9.31345C9.84084 13.5232 10.2686 14.1343 10.2686 14.8866C10.2686 15.6394 9.84049 16.25 9.31345 16.25H0.955149C0.427758 16.25 0 15.6389 0 14.8866C0 14.1338 0.427775 13.5232 0.955149 13.5232Z" fill="#1A1F44" />
                    <path d="M0.955149 6.70547H15.0449C15.5722 6.70547 16 7.31657 16 8.06889C16 8.82171 15.5719 9.43231 15.0449 9.43231H0.955149C0.427758 9.43231 0 8.82121 0 8.06889C0 7.31607 0.427775 6.70547 0.955149 6.70547Z" fill="#1A1F44" />
                    <path d="M15.0449 2.72693H0.955149C0.427758 2.72693 0 2.11583 0 1.36351C0 0.610689 0.428107 8.96454e-05 0.955149 8.96454e-05H15.0449C15.5722 8.96454e-05 16 0.611188 16 1.36351C16 2.11633 15.5726 2.72693 15.0449 2.72693Z" fill="#1A1F44" />
                  </svg>

                </div>
              </Grid>

            </Grid>
          </Grid>
        </Grid >

        <Dialog
          open={changePassword}
        >
          <DialogTitle>Change Password</DialogTitle>
          <DialogContent>
            <FormControl>
              <label>
                Old Password:
                <TextField
                  variant="outlined"
                  type="password"
                  name="oldPassword"
                  value={oldPassword}
                  onChange={(e) => this.handleChange(e, "oldPassword")}
                />
                {oldPasswordErr
                  ? CommonConfig.showErrorMsg(oldPasswordErrText)
                  : null}
              </label>
              <br />
              <br />
            </FormControl>
            <FormControl>
              <label>
                New Password:
                <TextField
                  variant="outlined"
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  onChange={(e) => this.handleChange(e, "newPassword")}
                />
                {newPasswordErr
                  ? CommonConfig.showErrorMsg(newPasswordErrText)
                  : null}
              </label>
              <br />
              <br />
            </FormControl>

            <FormControl>
              <label>
                Confirm Password:
                <TextField
                  variant="outlined"
                  type="password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => this.handleChange(e, "confirmPassword")}
                />
                {confirmPasswordErr
                  ? CommonConfig.showErrorMsg(confirmPasswordErrText)
                  : null}
              </label>
              <br />
              <br />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.changePassword}>Submit</Button>
            <Button onClick={this.handleClose}>Cancel</Button>
          </DialogActions>
        </Dialog>

        {/* <div className="dashboard-header">
          <div className="menu-icon" onClick={() => this.sideBarClose()}>
            <i className="fa fa-bars text-20"></i>
          </div>
          <div className="path-title p-pl-3">
            <label className="header-title">{this.state.mainTitle}</label>
            <label className="path-name">{this.state.breadCrumb}</label>
          </div>
          <div className="header-right-action">
            <div className="profile-section">
              <div
                className="d-flex align-items-center cursor-pointer"
                onClick={(e) => {
                  this.setState({ openOverlay: !this.state.openOverlay });
                }}
              >
                <div className="profile-img">
                  <img
                    src={
                      CommonConfig.isEmpty(profilePath)
                        ? userImage
                        : profilePath
                    }
                    width="150px"
                    alt="userImage"
                    onError={this.onError}
                  />
                  {this.state.openOverlay ? (
                    <div className="toggle-overlay">
                      <div className="main-overlay">
                        <div className="profile-detail">
                          <div
                            className="profile-img"
                            style={{ marginTop: "22px" }}
                          >
                            <img
                              src={
                                CommonConfig.isEmpty(profilePath)
                                  ? userImage
                                  : profilePath
                              }
                            />
                          </div>
                          <div className="profile-info">
                            <div className="username-overlay">
                              <p className="text-dark">{Name}</p>
                            </div>
                            <div className="usertype">
                              <span className="usertype-overlay-badge">
                                <p>{Role}</p>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="overlay-item">
                          <ul>
                            <li
                              onClick={() =>
                                this.props.history.push({
                                  pathname: "/edit-profile",
                                })
                              }
                            >
                              <div className="list-item">
                                <div className="list-item-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                  >
                                    <path
                                    d="M8.49979 0C3.81276 0 0 3.8134 0 8.49979C0 10.9655 1.05113 13.2025 2.7554 14.7654L2.75116 14.7682L2.84265 14.8455C3.56063 15.4853 4.3908 16.0048 5.30647 16.3735C5.35778 16.3945 5.40858 16.4175 5.46025 16.4376C5.56785 16.4786 5.67719 16.515 5.78692 16.5518C5.90525 16.5916 6.0247 16.6285 6.1449 16.6631C6.2299 16.6876 6.31453 16.713 6.40041 16.7346C6.6171 16.7899 6.83566 16.839 7.05659 16.8769C7.07419 16.8801 7.09154 16.8815 7.10889 16.8815C7.25692 16.8815 7.38723 16.7752 7.4132 16.6247C7.44191 16.4565 7.32932 16.2969 7.16093 16.2684C7.16031 16.2684 7.15981 16.2677 7.15919 16.2677C6.95648 16.2331 6.758 16.1873 6.56168 16.1378C6.4934 16.1204 6.42513 16.1028 6.35747 16.0837C6.22554 16.0466 6.0961 16.0049 5.96741 15.9616C5.8135 15.9095 5.66147 15.8527 5.51155 15.7909C5.44877 15.7652 5.38586 15.7402 5.32407 15.713C5.19613 15.6564 5.06919 15.597 4.94436 15.5336C4.93288 15.5278 4.92202 15.5218 4.91053 15.5161C4.49887 15.3047 4.10433 15.0575 3.73334 14.7756C3.74445 14.7691 3.75494 14.7628 3.76567 14.7567L6.21003 13.4236C6.63007 13.1943 6.89117 12.7547 6.89117 12.276V11.1623L6.81927 11.0769C6.81315 11.0694 6.14686 10.2623 5.89235 9.15541L5.86463 9.03333L5.75891 8.96493C5.61025 8.86882 5.52125 8.70805 5.52125 8.53467V7.43899C5.52125 7.29533 5.58291 7.16152 5.69388 7.06104L5.79598 6.96855V5.2469L5.79274 5.2067C5.79186 5.19934 5.70074 4.45591 6.22437 3.85914C6.67199 3.3495 7.43751 3.09086 8.50037 3.09086C9.55898 3.09086 10.3229 3.34737 10.7709 3.85313C11.2939 4.44377 11.2085 5.20095 11.2079 5.20718L11.205 6.96939L11.3067 7.06126C11.4177 7.16136 11.479 7.29542 11.479 7.43921V8.53488C11.479 8.75869 11.3324 8.9539 11.1143 9.02132C10.9514 9.07175 10.8596 9.24525 10.9097 9.40851C10.9597 9.5714 11.133 9.66277 11.2961 9.61246C11.7752 9.46443 12.0972 9.03167 12.0972 8.53488V7.4392C12.0972 7.17159 11.9987 6.91122 11.8232 6.70688V5.26457C11.8393 5.1038 11.8964 4.19934 11.2414 3.45254C10.6722 2.80222 9.74996 2.47245 8.50065 2.47245C7.25134 2.47245 6.32953 2.80174 5.75985 3.45178C5.10492 4.19858 5.16196 5.10403 5.17806 5.26418V6.70685C5.00244 6.91118 4.90371 7.17156 4.90371 7.43917V8.53484C4.90371 8.87509 5.05674 9.19252 5.31787 9.40671C5.56825 10.3874 6.08326 11.1297 6.27374 11.3814V12.276C6.27374 12.5282 6.13594 12.7601 5.91438 12.8812L3.47076 14.2143C3.391 14.2579 3.31224 14.3083 3.23335 14.3652C1.61756 12.9138 0.618609 10.8154 0.618609 8.50004C0.618609 4.15396 4.15433 0.618239 8.50041 0.618239C12.8465 0.618239 16.3819 4.15396 16.3819 8.50004C16.3819 8.67092 16.5206 8.80897 16.6911 8.80897C16.8617 8.80897 17 8.67104 17 8.50004C17 3.81333 13.1876 0.000246564 8.50021 0.000246564L8.49979 0ZM15.5057 10.2001C15.4277 10.2001 15.3496 10.2299 15.29 10.2894L14.4128 11.1669L15.7242 12.4776L16.602 11.6003C16.7207 11.4816 16.7204 11.2885 16.602 11.1701L15.7209 10.2886C15.6616 10.2294 15.5836 10.2 15.5056 10.2L15.5057 10.2001ZM13.9759 11.6036L10.8095 14.7692L12.1215 16.081L15.2872 12.9149L13.9758 11.6036H13.9759ZM10.5306 15.3649L10.1574 16.7337L11.5262 16.3601L10.5308 15.365L10.5306 15.3649Z"
                                    fill="black"
                                  />
                                </svg>
                              </div>
                              <div className="list-item-title">
                                <a href="javascript:;">Edit Profile</a>
                              </div>
                            </div>
                          </li>
                          <li onClick={(e) => this.openModel(e)}>
                            <div className="list-item">
                              <div className="list-item-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="17"
                                  height="17"
                                  viewBox="0 0 17 17"
                                  fill="none"
                                >
                                  <path
                                    d="M8.49979 0C3.81276 0 0 3.8134 0 8.49979C0 10.9655 1.05113 13.2025 2.7554 14.7654L2.75116 14.7682L2.84265 14.8455C3.56063 15.4853 4.3908 16.0048 5.30647 16.3735C5.35778 16.3945 5.40858 16.4175 5.46025 16.4376C5.56785 16.4786 5.67719 16.515 5.78692 16.5518C5.90525 16.5916 6.0247 16.6285 6.1449 16.6631C6.2299 16.6876 6.31453 16.713 6.40041 16.7346C6.6171 16.7899 6.83566 16.839 7.05659 16.8769C7.07419 16.8801 7.09154 16.8815 7.10889 16.8815C7.25692 16.8815 7.38723 16.7752 7.4132 16.6247C7.44191 16.4565 7.32932 16.2969 7.16093 16.2684C7.16031 16.2684 7.15981 16.2677 7.15919 16.2677C6.95648 16.2331 6.758 16.1873 6.56168 16.1378C6.4934 16.1204 6.42513 16.1028 6.35747 16.0837C6.22554 16.0466 6.0961 16.0049 5.96741 15.9616C5.8135 15.9095 5.66147 15.8527 5.51155 15.7909C5.44877 15.7652 5.38586 15.7402 5.32407 15.713C5.19613 15.6564 5.06919 15.597 4.94436 15.5336C4.93288 15.5278 4.92202 15.5218 4.91053 15.5161C4.49887 15.3047 4.10433 15.0575 3.73334 14.7756C3.74445 14.7691 3.75494 14.7628 3.76567 14.7567L6.21003 13.4236C6.63007 13.1943 6.89117 12.7547 6.89117 12.276V11.1623L6.81927 11.0769C6.81315 11.0694 6.14686 10.2623 5.89235 9.15541L5.86463 9.03333L5.75891 8.96493C5.61025 8.86882 5.52125 8.70805 5.52125 8.53467V7.43899C5.52125 7.29533 5.58291 7.16152 5.69388 7.06104L5.79598 6.96855V5.2469L5.79274 5.2067C5.79186 5.19934 5.70074 4.45591 6.22437 3.85914C6.67199 3.3495 7.43751 3.09086 8.50037 3.09086C9.55898 3.09086 10.3229 3.34737 10.7709 3.85313C11.2939 4.44377 11.2085 5.20095 11.2079 5.20718L11.205 6.96939L11.3067 7.06126C11.4177 7.16136 11.479 7.29542 11.479 7.43921V8.53488C11.479 8.75869 11.3324 8.9539 11.1143 9.02132C10.9514 9.07175 10.8596 9.24525 10.9097 9.40851C10.9597 9.5714 11.133 9.66277 11.2961 9.61246C11.7752 9.46443 12.0972 9.03167 12.0972 8.53488V7.4392C12.0972 7.17159 11.9987 6.91122 11.8232 6.70688V5.26457C11.8393 5.1038 11.8964 4.19934 11.2414 3.45254C10.6722 2.80222 9.74996 2.47245 8.50065 2.47245C7.25134 2.47245 6.32953 2.80174 5.75985 3.45178C5.10492 4.19858 5.16196 5.10403 5.17806 5.26418V6.70685C5.00244 6.91118 4.90371 7.17156 4.90371 7.43917V8.53484C4.90371 8.87509 5.05674 9.19252 5.31787 9.40671C5.56825 10.3874 6.08326 11.1297 6.27374 11.3814V12.276C6.27374 12.5282 6.13594 12.7601 5.91438 12.8812L3.47076 14.2143C3.391 14.2579 3.31224 14.3083 3.23335 14.3652C1.61756 12.9138 0.618609 10.8154 0.618609 8.50004C0.618609 4.15396 4.15433 0.618239 8.50041 0.618239C12.8465 0.618239 16.3819 4.15396 16.3819 8.50004C16.3819 8.67092 16.5206 8.80897 16.6911 8.80897C16.8617 8.80897 17 8.67104 17 8.50004C17 3.81333 13.1876 0.000246564 8.50021 0.000246564L8.49979 0ZM15.5057 10.2001C15.4277 10.2001 15.3496 10.2299 15.29 10.2894L14.4128 11.1669L15.7242 12.4776L16.602 11.6003C16.7207 11.4816 16.7204 11.2885 16.602 11.1701L15.7209 10.2886C15.6616 10.2294 15.5836 10.2 15.5056 10.2L15.5057 10.2001ZM13.9759 11.6036L10.8095 14.7692L12.1215 16.081L15.2872 12.9149L13.9758 11.6036H13.9759ZM10.5306 15.3649L10.1574 16.7337L11.5262 16.3601L10.5308 15.365L10.5306 15.3649Z"
                                    fill="black"
                                  />
                                </svg>
                              </div>
                              <div className="list-item-title">
                                <a href="javascript:;">Change Password</a>
                              </div>
                            </div>
                          </li>
                          <li onClick={(e) => this.handleLogout()}>
                            <div className="list-item">
                              <div className="list-item-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="17"
                                  height="17"
                                  viewBox="0 0 17 17"
                                  fill="none"
                                >
                                  <path
                                    d="M8.49979 0C3.81276 0 0 3.8134 0 8.49979C0 10.9655 1.05113 13.2025 2.7554 14.7654L2.75116 14.7682L2.84265 14.8455C3.56063 15.4853 4.3908 16.0048 5.30647 16.3735C5.35778 16.3945 5.40858 16.4175 5.46025 16.4376C5.56785 16.4786 5.67719 16.515 5.78692 16.5518C5.90525 16.5916 6.0247 16.6285 6.1449 16.6631C6.2299 16.6876 6.31453 16.713 6.40041 16.7346C6.6171 16.7899 6.83566 16.839 7.05659 16.8769C7.07419 16.8801 7.09154 16.8815 7.10889 16.8815C7.25692 16.8815 7.38723 16.7752 7.4132 16.6247C7.44191 16.4565 7.32932 16.2969 7.16093 16.2684C7.16031 16.2684 7.15981 16.2677 7.15919 16.2677C6.95648 16.2331 6.758 16.1873 6.56168 16.1378C6.4934 16.1204 6.42513 16.1028 6.35747 16.0837C6.22554 16.0466 6.0961 16.0049 5.96741 15.9616C5.8135 15.9095 5.66147 15.8527 5.51155 15.7909C5.44877 15.7652 5.38586 15.7402 5.32407 15.713C5.19613 15.6564 5.06919 15.597 4.94436 15.5336C4.93288 15.5278 4.92202 15.5218 4.91053 15.5161C4.49887 15.3047 4.10433 15.0575 3.73334 14.7756C3.74445 14.7691 3.75494 14.7628 3.76567 14.7567L6.21003 13.4236C6.63007 13.1943 6.89117 12.7547 6.89117 12.276V11.1623L6.81927 11.0769C6.81315 11.0694 6.14686 10.2623 5.89235 9.15541L5.86463 9.03333L5.75891 8.96493C5.61025 8.86882 5.52125 8.70805 5.52125 8.53467V7.43899C5.52125 7.29533 5.58291 7.16152 5.69388 7.06104L5.79598 6.96855V5.2469L5.79274 5.2067C5.79186 5.19934 5.70074 4.45591 6.22437 3.85914C6.67199 3.3495 7.43751 3.09086 8.50037 3.09086C9.55898 3.09086 10.3229 3.34737 10.7709 3.85313C11.2939 4.44377 11.2085 5.20095 11.2079 5.20718L11.205 6.96939L11.3067 7.06126C11.4177 7.16136 11.479 7.29542 11.479 7.43921V8.53488C11.479 8.75869 11.3324 8.9539 11.1143 9.02132C10.9514 9.07175 10.8596 9.24525 10.9097 9.40851C10.9597 9.5714 11.133 9.66277 11.2961 9.61246C11.7752 9.46443 12.0972 9.03167 12.0972 8.53488V7.4392C12.0972 7.17159 11.9987 6.91122 11.8232 6.70688V5.26457C11.8393 5.1038 11.8964 4.19934 11.2414 3.45254C10.6722 2.80222 9.74996 2.47245 8.50065 2.47245C7.25134 2.47245 6.32953 2.80174 5.75985 3.45178C5.10492 4.19858 5.16196 5.10403 5.17806 5.26418V6.70685C5.00244 6.91118 4.90371 7.17156 4.90371 7.43917V8.53484C4.90371 8.87509 5.05674 9.19252 5.31787 9.40671C5.56825 10.3874 6.08326 11.1297 6.27374 11.3814V12.276C6.27374 12.5282 6.13594 12.7601 5.91438 12.8812L3.47076 14.2143C3.391 14.2579 3.31224 14.3083 3.23335 14.3652C1.61756 12.9138 0.618609 10.8154 0.618609 8.50004C0.618609 4.15396 4.15433 0.618239 8.50041 0.618239C12.8465 0.618239 16.3819 4.15396 16.3819 8.50004C16.3819 8.67092 16.5206 8.80897 16.6911 8.80897C16.8617 8.80897 17 8.67104 17 8.50004C17 3.81333 13.1876 0.000246564 8.50021 0.000246564L8.49979 0ZM15.5057 10.2001C15.4277 10.2001 15.3496 10.2299 15.29 10.2894L14.4128 11.1669L15.7242 12.4776L16.602 11.6003C16.7207 11.4816 16.7204 11.2885 16.602 11.1701L15.7209 10.2886C15.6616 10.2294 15.5836 10.2 15.5056 10.2L15.5057 10.2001ZM13.9759 11.6036L10.8095 14.7692L12.1215 16.081L15.2872 12.9149L13.9758 11.6036H13.9759ZM10.5306 15.3649L10.1574 16.7337L11.5262 16.3601L10.5308 15.365L10.5306 15.3649Z"
                                    fill="black"
                                  />
                                </svg>
                              </div>
                              <div className="list-item-title">
                                <a href="javascript:;">Logout</a>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="last-login-info">
                        <p>Last login: {LastLogin}</p>
                      </div>
                    </div>
                  </div>
                ) : null}
                <label className="userActive"></label>
              </div>
              <div className="user-detail">
                <div className="username-overlay">
                  <p className="text-dark">{Name}</p>
                </div>
                <div className="usertype">
                  <span className="usertype-overlay-badge">
                    <p>{Role}</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <OverlayPanel
            ref={(el) => (this.op = el)}
            id="overlay_panel"
            style={{ width: "450px" }}
            className="profile-menu"
          >
            <div className="profile-menu-container">
              <hr />
              <ul className="menu-options">
                <li
                  className="menu-link"
                  onClick={() =>
                    this.props.history.push({ pathname: "/edit-profile" })
                  }
                >
                  <i className="icon-edit-profile"></i>
                  <span>Edit Profile</span>
                  <label className="list-dot"></label>
                </li>
                <li className="menu-link" onClick={(e) => this.openModel(e)}>
                  <i className="icon-change-password"></i>
                  <span>Change Password</span>
                  <label className="list-dot"></label>
                </li>
                <li
                  onClick={(e) => this.handleLogout()}
                  className="menu-link"
                >
                  <i className="icon-logout"></i>
                  <span>Logout</span>
                  <label className="list-dot"></label>
                </li>
              </ul>
              <hr />
            </div>
          </OverlayPanel>
        </div>

        <Dialog
          open={changePassword}
        >
          <DialogTitle>Change Password</DialogTitle>
          <DialogContent>
            <FormControl>
              <label>
                Old Password:
                <TextField
                  variant="outlined"
                  type="password"
                  name="oldPassword"
                  value={oldPassword}
                  onChange={(e) => this.handleChange(e, "oldPassword")}
                />
                {oldPasswordErr
                  ? CommonConfig.showErrorMsg(oldPasswordErrText)
                  : null}
              </label>
              <br />
              <br />
            </FormControl>
            <FormControl>
              <label>
                New Password:
                <TextField
                  variant="outlined"
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  onChange={(e) => this.handleChange(e, "newPassword")}
                />
                {newPasswordErr
                  ? CommonConfig.showErrorMsg(newPasswordErrText)
                  : null}
              </label>
              <br />
              <br />
            </FormControl>

            <FormControl>
              <label>
                Confirm Password:
                <TextField
                  variant="outlined"
                  type="password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => this.handleChange(e, "confirmPassword")}
                />
                {confirmPasswordErr
                  ? CommonConfig.showErrorMsg(confirmPasswordErrText)
                  : null}
              </label>
              <br />
              <br />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.changePassword}>Submit</Button>
            <Button onClick={this.handleClose}>Cancel</Button>
          </DialogActions>
        </Dialog>
      </div> */}
      </nav >
    );
  }
}
